<template>
  <div id="app">
    <transition  name="fade" mode="out-in">
    <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #757588;
  background: #F7F7F7;
}
</style>



// WEBPACK FOOTER //
// src/framework/pc/App.vue